import { ITextMessageSource } from "atlas-shared";
import { ITextMessageSourceStore } from "@Store/types/text_message_source.types";
import { TextMessageSourceActions } from "@Store/types/text_message_source.types";
import { TTextMessageSourceActionTypes } from "@Store/types/text_message_source.types";

export const TextMessageSourceReducer = (
  state: ITextMessageSourceStore = {
    loaded: false,
    loading: false,
    text_message_sources: [],
    dict: {},
  },
  action: TTextMessageSourceActionTypes
): ITextMessageSourceStore => {
  switch (action.type) {
    case TextMessageSourceActions.LOADING:
      return { ...state, loading: true };
    case TextMessageSourceActions.SET_STATE:
      const dict: ITextMessageSourceStore["dict"] = {};

      action.payload.forEach(
        (text_message_source: ITextMessageSource) =>
          (dict[text_message_source.id!] = text_message_source)
      );

      return { ...state, loaded: true, loading: false, text_message_sources: action.payload, dict };
    case TextMessageSourceActions.ADD_STATE:
      return {
        ...state,
        text_message_sources: [...state.text_message_sources, action.payload],
        dict: { ...state.dict, [action.payload.id!]: action.payload },
      };
    case TextMessageSourceActions.REMOVE_STATE: {
      const { [action.payload!]: _deleted, ...dict } = state.dict;

      return {
        ...state,
        text_message_sources: state.text_message_sources.filter(
          (item: ITextMessageSource) => item.id !== action.payload
        ),
        dict,
      };
    }
    case TextMessageSourceActions.UPDATE_STATE:
      const text_message_sources = [...state.text_message_sources];
      const index = state.text_message_sources.findIndex(
        (text_message_source: ITextMessageSource) => text_message_source.id === action.payload.id
      );

      if (!~index) text_message_sources.push(action.payload);
      else text_message_sources[index] = action.payload;

      return {
        ...state,
        text_message_sources: text_message_sources,
        dict: { ...state.dict, [action.payload.id!]: action.payload },
      };
    default:
      return state;
  }
};
